/*
 * File: EventsHandler.js
 * Project: mp-mobile-app
 *
 * Copyright (c) 2020 MacPractice, Inc. All rights reserved.
 *
 * Description: Handles click and keypress events so the auto logout alert timer restarts
 */
import { useEffect, useContext } from "react";
import { LoginContext } from "../state/LoginProvider";

const EventHandlers = () => {
  // provider state
  const { timer, dialog } = useContext(LoginContext);

  useEffect(() => {
    const handleEvent = () => timer.start();

    // only handle events if the user is still logged in
    if (dialog.open === false) {
      document.addEventListener("click", handleEvent);
      document.addEventListener("keypress", handleEvent);
    }

    return () => {
      document.removeEventListener("click", handleEvent);
      document.removeEventListener("keypress", handleEvent);
    };

    // watch for dialog open changes
  }, [timer, dialog.open]);

  return null;
};

export default EventHandlers;
